<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/160SeKY/tc-custom/9781429940900.jpg?1737334837184" alt="This image is the cover for the book Alix and Nicky"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alix and Nicky
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The dramatic story of Emperor Nicholas II and his wife Alexandra Fyodorovna, the last Tsar and Tsarina of Russia—A penetrating and deeply personal study that gives profound psychological insight into their marriage and how it shaped the  events that engulfed them.</i><br/><br/>There are few characters in history about whom opinion has been more divided than the last Tsar of Russia, Nicholas II, and his wife the Empress Alexandra Fyodorovna. On one hand, they are venerated as saints, innocent victims of Bolshevik assassins, and on the other they are impugned as the unwitting harbingers of revolution and imperial collapse, blamed for all the ills that befell the Russian people in the 20th century. Theirs was also a tragic love story; for whatever else can be said of them, there can be no doubt that Alix and Nicky adored one another. Soon after their engagement, Alix wrote in her fiancé's diary: "Ever true and ever loving, faithful, pure and strong as death"—words which met their fulfillment twenty-four years later in a blood-spattered cellar in Ekaterinburg.<br/><br/>Through the letters and diaries written by the couple and by those around them, Virginia Rounding presents an intimate, penetrating, and fresh portrayal of these two complex figures and of their passion—their love and their suffering. She explores the nature and possible causes of the Empress's ill health, and examines in depth the enigmatic triangular relationship between Nicky, Alix and their ‘favourite,' Ania Vyrubova, protégée of the infamous Rasputin, extracting the meaning from words left unsaid, from hints and innuendoes..<br/><br/>The story of Alix and Nicky, of their four daughters known collectively as ‘OTMA' and of their hemophiliac little boy Alexei, is endlessly fascinating, and Rounding makes these characters come alive, presenting them in all their human dimensions and expertly leading the reader into their vanished world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Rounding
      </h2>
      
      <p class="authorDescription body article"><P>VIRGINIA ROUNDING is a translator and writer who lives in London. She studied Russian at the University of London.  She is the author of the critically acclaimed <I>Catherine the Great</I> and <I>Grandes Horizontales</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0280f3b2